// extracted by mini-css-extract-plugin
export default {"infoCard":"Post_infoCard__OWsw0","rightBlock":"Post_rightBlock__8en8X"};